import { invariant } from 'ts-invariant';
import { getApolloContext } from './ApolloContext';
import { requireReactLazily } from '../react';
export var ApolloConsumer = function (props) {
    var React = requireReactLazily();
    var ApolloContext = getApolloContext();
    return (React.createElement(ApolloContext.Consumer, null, function (context) {
        invariant(context && context.client, 'Could not find "client" in the context of ApolloConsumer. ' +
            'Wrap the root component in an <ApolloProvider>.');
        return props.children(context.client);
    }));
};
//# sourceMappingURL=ApolloConsumer.js.map